import React from "react";
import { Grid, Link } from "@mui/material";
// Image
import esstartEmblem from "../assets/image/favicon-esstart.png";
import siteLogo from "../assets/image/esstart-logo.svg";
import { useSelector } from "react-redux";

export const Header = () => {
	const { eventVerfiyData } = useSelector((store: any) => store?.event);
	const currentProductName = !!eventVerfiyData
		? Object.keys(eventVerfiyData).filter(
				(keyName) =>
					!["guestURL", "distinctName", "activityCode"]?.includes(keyName)
		  )?.[0]
		: "";

	const isEnterActivityCodePage = window.location?.pathname?.length < 2; // either the pathname is "/" or invalid route

	return (
		<>
			{!!eventVerfiyData?.[currentProductName]?.isWhiteLabelEnabledForHost ? (
				<div style={{ marginBottom: "1rem" }}></div>
			) : (
				<Grid
					container
					spacing={0}
					alignItems='center'
					paddingY={2}
					paddingX={2}
				>
					<Grid item xs={6}>
						<Link
							href={process.env.REACT_APP_DEV_WEBSITE_URL_LIVE}
							target='_blank'
							rel='noopener noreferrer'
							display='inline-block'
						>
							{!isEnterActivityCodePage ? (
								<>
									{!!eventVerfiyData && (
										<img src={siteLogo} alt='Site Logo' width={"190px"} />
									)}
								</>
							) : (
								<>
									<img src={esstartEmblem} alt='Site Logo' width={"45px"} />
								</>
							)}
						</Link>
					</Grid>
				</Grid>
			)}
		</>
	);
};
